import * as React from "react";
import { CreateOrEditReleasePage } from "./CreateOrEditReleasePage";
export function CreateReleasePage() {
    return <CreateOrEditReleasePage />;
}
